var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlooIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 50,
    viewBox: "0 0 61 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10.4651C0.5 8.85964 1.84315 7.55814 3.5 7.55814C5.15685 7.55814 6.5 8.85964 6.5 10.4651V39.5349C6.5 41.1404 5.15685 42.4419 3.5 42.4419C1.84315 42.4419 0.5 41.1404 0.5 39.5349V10.4651Z",
    fill: "url(#paint0_linear_117_77797)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 16.2791C11.3 14.6736 12.6431 13.3721 14.3 13.3721C15.9569 13.3721 17.3 14.6736 17.3 16.2791V33.7209C17.3 35.3264 15.9569 36.6279 14.3 36.6279C12.6431 36.6279 11.3 35.3264 11.3 33.7209V16.2791Z",
    fill: "url(#paint1_linear_117_77797)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1 11.0465C22.1 9.44103 23.4431 8.13953 25.1 8.13953C26.7569 8.13953 28.1 9.44103 28.1 11.0465V38.9535C28.1 40.559 26.7569 41.8605 25.1 41.8605C23.4431 41.8605 22.1 40.559 22.1 38.9535V11.0465Z",
    fill: "url(#paint2_linear_117_77797)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9 2.90698C32.9 1.3015 34.2431 0 35.9 0C37.5569 0 38.9 1.3015 38.9 2.90698V47.093C38.9 48.6985 37.5569 50 35.9 50C34.2431 50 32.9 48.6985 32.9 47.093V2.90698Z",
    fill: "url(#paint3_linear_117_77797)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7 11.7571C43.7 10.1516 45.0431 8.85013 46.7 8.85013C48.3569 8.85013 49.7 10.1516 49.7 11.7571V38.2429C49.7 39.8484 48.3569 41.1499 46.7 41.1499C45.0431 41.1499 43.7 39.8484 43.7 38.2429V11.7571Z",
    fill: "url(#paint4_linear_117_77797)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 14.9871C54.5 13.3816 55.8431 12.0801 57.5 12.0801C59.1569 12.0801 60.5 13.3816 60.5 14.9871V35.0129C60.5 36.6184 59.1569 37.9199 57.5 37.9199C55.8431 37.9199 54.5 36.6184 54.5 35.0129V14.9871Z",
    fill: "url(#paint5_linear_117_77797)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_117_77797",
    x1: 2.5339,
    y1: 27.1739,
    x2: 73.4679,
    y2: 38.6327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62ABE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_117_77797",
    x1: 2.5339,
    y1: 27.1739,
    x2: 73.4679,
    y2: 38.6327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62ABE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_117_77797",
    x1: 2.5339,
    y1: 27.1739,
    x2: 73.4679,
    y2: 38.6327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62ABE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_117_77797",
    x1: 2.5339,
    y1: 27.1739,
    x2: 73.4679,
    y2: 38.6327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62ABE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_117_77797",
    x1: 2.5339,
    y1: 27.1739,
    x2: 73.4679,
    y2: 38.6327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62ABE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_117_77797",
    x1: 2.5339,
    y1: 27.1739,
    x2: 73.4679,
    y2: 38.6327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62ABE0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlooIcon);
export default __webpack_public_path__ + "static/media/gloo-icon.ad8ac677735fd0f6f10a674b392c9408.svg";
export { ForwardRef as ReactComponent };